<template>
  <div class="container page">
    <van-nav-bar :title="$t('router.Recharge.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="section-title">{{ $t('recharge.chooseCoin') }}</div>
      <div class="coin-list">
        <div class="coin-item" v-for="item in coins" :key="item.coin" :class="{active: coin === item.coin}" @click="chooseCoin(item)">
          <span class="coin-name">{{ item.coin.toUpperCase() }}</span>
          <span class="coin-addr">{{ item.addr }}</span>
        </div>
        <div class="coin-empty" v-if="!coins.length">{{ $t('common.emptyData') }}</div>
      </div>
      <div class="section-box" v-if="current">
        <div class="section-title">{{ $t('recharge.address') }}</div>
        <div class="addr-row">
          <span class="addr-text">{{ current.addr }}</span>
          <span class="copy-btn" @click="copyAddr()">{{ $t('recharge.copy') }}</span>
        </div>
        <!-- 二维码由前端按地址现场生成（qrcode 包画 canvas）。原先用后台上传的静态图，
           上传/路径任一环节挂掉图就裂；地址本身就是数据源，本地生成不依赖任何外链 -->
        <canvas v-show="current" ref="qrCanvas" class="qrcode" width="300px" height="300px"></canvas>
      </div>
      <div class="section-box">
        <div class="section-title">{{ $t('recharge.amount') }}</div>
        <div class="money-row">
          <span class="money-type">¥</span>
          <van-field v-model="money" type="number" />
        </div>
      </div>
      <div class="section-box">
        <div class="section-title">{{ $t('recharge.uploadShot') }}</div>
        <van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" :disabled="uploading"/>
      </div>
      <van-button class="submit-btn" type="default" @click="doApply()">{{ $t('recharge.submit') }}</van-button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  data() {
    return {
      coins: [],
      coin: '',
      current: null,
      money: '',
      fileList: [],
      screenshot: '',
      uploading: false
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getWalletConfig(){
      this.$http({
        method: 'get',
        url: 'system_wallet_config'
      }).then(res=>{
        if(res.code === 200){
          this.coins = Array.isArray(res.data) ? res.data : [];
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    chooseCoin(item){
      this.coin = item.coin;
      this.current = item;
      this.drawQr(item.addr);
    },
    // 地址画进 canvas；画不出来时降级为隐藏（地址文本+复制仍在，不阻塞充值）
    drawQr(addr){
      this.$nextTick(()=>{
        const cv = this.$refs.qrCanvas;
        if(!cv || !addr){ return; }
        QRCode.toCanvas(cv, addr, { width: 300, margin: 1 }, (err)=>{
          if(err){ console.error('qrcode draw fail', err); }
        });
      });
    },
    copyAddr(){
      const addr = this.current ? this.current.addr : '';
      if(!addr){ return; }
      const ok = () => { this.$toast(this.$t('recharge.copied')); };
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(addr).then(ok).catch(()=>{ this.fallbackCopy(addr, ok); });
      }else {
        this.fallbackCopy(addr, ok);
      }
    },
    // HTTP 环境下 clipboard API 可能不可用，execCommand 兜底
    fallbackCopy(text, ok){
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        ok();
      } catch (e) {
        this.$toast.fail(String(e));
      }
      document.body.removeChild(ta);
    },
    afterRead(file){
      // file.file 为原生 File，FormData 直接 append，由拦截器 FormData 分支透传
      const formData = new FormData();
      formData.append('file', file.file);
      this.$set(file, 'status', 'uploading');
      this.uploading = true;
      this.$http({
        method: 'post',
        url: 'recharge_upload',
        data: formData,
        timeout: 30000
      }).then(res=>{
        this.uploading = false;
        if(res.code === 200){
          this.$set(file, 'status', 'done');
          this.screenshot = res.data.path;
        }else {
          this.fileList = [];
          this.screenshot = '';
          this.$toast(res.msg);
        }
      }).catch(()=>{
        this.uploading = false;
        this.fileList = [];
        this.screenshot = '';
      })
    },
    doApply(){
      if(!this.coin){
        this.$toast(this.$t('recharge.chooseCoin'));
        return false;
      }
      if(!(parseFloat(this.money) > 0)){
        this.$toast(this.$t('lottery.fillAmount'));
        return false;
      }
      if(!this.screenshot){
        this.$toast(this.$t('recharge.uploadShot'));
        return false;
      }
      this.$http({
        method: 'post',
        data:{coin:this.coin, money:this.money, screenshot:this.screenshot},
        url: 'recharge_apply'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.$router.push({path:'/Mine'});
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getWalletConfig();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
  padding-bottom: 40px;
}
.section-title{
  padding: 20px 20px 10px;
  font-size: 30px;
  color: #000;
}
.coin-list{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 10px;
}
.coin-item{
  display: flex;
  flex-direction: column;
  width: 335px;
  margin: 10px;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 10px;
  border: 2px solid #fff;
}
.coin-item.active{
  border: 2px solid #7e5678;
}
.coin-item .coin-name{
  font-size: 32px;
  font-weight: bolder;
  color: #000;
}
.coin-item .coin-addr{
  margin-top: 10px;
  font-size: 22px;
  color: #979799;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.coin-empty{
  width: 100%;
  padding: 30px 0;
  text-align: center;
  font-size: 26px;
  color: #979799;
}
.section-box{
  margin: 20px;
  padding: 0 20px 20px;
  background-color: #fff;
  border-radius: 10px;
}
.section-box .section-title{
  padding: 20px 0 10px;
}
.addr-row{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.addr-row .addr-text{
  flex: 1;
  font-size: 26px;
  color: #000;
  word-break: break-all;
}
.addr-row .copy-btn{
  margin-left: 20px;
  padding: 8px 24px;
  font-size: 24px;
  color: #fff;
  border-radius: 30px;
  background: linear-gradient(90deg,#e6c3a1,#7e5678);
  white-space: nowrap;
}
.section-box .qrcode{
  margin-top: 20px;
}
.money-row{
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #f2f2f5;
}
.money-row .money-type{
  font-size: 50px;
  color: #000;
}
.money-row .van-cell{
  flex: 1;
  font-size: 50px;
  padding: 0 0 0 10px;
}
.submit-btn{
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
